import React from 'react';
import Maintenances from '../../components/Maintenances';
import { useSelector, useDispatch } from 'react-redux';
import { selectMaintenance } from '../../actions';

const MaintenancesContainer = () => {
  const { personalization } = useSelector(state => ({
    personalization: state.personalization
  }));

  const dispatch = useDispatch();

  const pickMaintenance = (tipo, modelo, version, anio, color, accesorioId, state) => {
    dispatch(selectMaintenance(tipo, modelo, version, anio, color, accesorioId, state));
  }

  return (
    <Maintenances personalization={personalization} pickMaintenance={pickMaintenance}/>
  );
};

export default MaintenancesContainer
